<script setup>
import bookingBg from '@/assets/Booking/Booking.jpg';
import { useRouter } from 'vue-router';
import { getAuth } from "firebase/auth";
import { getFirestore,doc, getDoc, updateDoc  } from "firebase/firestore";
import { onMounted } from "vue";
import CleanupReservations from "@/components/CleanupReservations.vue";

const router = useRouter();
const auth = getAuth();
const db = getFirestore();

let reservationId = null;

onMounted(async () => {
  try {
    const user = auth.currentUser;
    if (!user) {
      router.push("/login");
      return;
    }

    reservationId = localStorage.getItem('reservationId'); // Get from localStorage
    const selectedDuration = localStorage.getItem("duration");

    if (!selectedDuration || !reservationId) {
      console.error("Missing reservation data");
      router.push("/bookingduration");
      return;
    }

    // Verify the reservation exists and belongs to this user
    const reservationRef = doc(db, "reservations", reservationId);
    const docSnap = await getDoc(reservationRef);
    
    if (!docSnap.exists() || docSnap.data().userId !== user.uid) {
      console.error("Reservation not found or doesn't belong to user.");
      router.push("/bookingduration");
      return;
    }
  } catch (error) {
    console.error("Error fetching reservation:", error);
    router.push("/login");
  }
});

const handleOrderOnArrival = () => {
  if (reservationId) {
  router.push('/choose-table');
  } else {
    console.error("No reservation found");
    router.push("/login");
  }
};

const handlePreOrder = async () => {
  if (reservationId) {
    try {
      // Update the reservation to mark preorder as true
      const reservationRef = doc(db, "reservations", reservationId);
      await updateDoc(reservationRef, {
        preorder: true
      });
      console.log("Preorder status updated to true");
      router.push('/menu');
    } catch (error) {
      console.error("Error updating preorder status:", error);
      // Still navigate to menu even if update fails
      router.push('/menu');
    }
  } else {
    console.error("No reservation found");
    router.push("/login");
  }
};
</script>

<template>
  <div
    class="min-h-screen w-full relative flex flex-col justify-between"
    :style="{
      backgroundImage: `linear-gradient(rgba(10,10,10,0.9),rgba(10,10,10,0.7)), url('${bookingBg}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }"
  >
    <CleanupReservations />
    <div class="flex flex-col justify-center items-center min-h-screen">
      <h1 class="text-2xl md:text-3xl font-semibold text-white mb-4 tracking-wider text-center" style="font-family: 'DM Sans', sans-serif;">{{ $t('preorder.title') }}</h1>
      <p class="text-white text-center mb-8 opacity-80 max-w-md">
        {{ $t('preorder.subtitle') }}
      </p>
      <div class="flex flex-col md:flex-row gap-4 w-full max-w-xl justify-center mb-8 px-4">
        <button @click="handlePreOrder" class="w-full md:w-auto px-8 py-3 border-2 border-[#F5BE32] text-[#F5BE32] font-semibold transition bg-transparent shadow-[0_0_16px_2px_rgba(243,211,130,0.7)] ring-2 ring-[#F5BE32] hover:bg-[#F5BE32] hover:text-white hover:shadow-[0_0_32px_8px_rgba(243,211,130,0.9)] focus:outline-none focus:ring-4 focus:ring-[#F5BE32] rounded-none" style="font-family: 'Cormorant SC', serif;">{{ $t('preorder.preorderBtn') }}</button>
        <button @click="handleOrderOnArrival" class="w-full md:w-auto px-8 py-3 border-2 border-[#F5BE32] text-[#F5BE32] font-semibold transition bg-transparent shadow-[0_0_16px_2px_rgba(243,211,130,0.7)] ring-2 ring-[#F5BE32] hover:bg-[#F5BE32] hover:text-white hover:shadow-[0_0_32px_8px_rgba(243,211,130,0.9)] focus:outline-none focus:ring-4 focus:ring-[#F5BE32] rounded-none" style="font-family: 'Cormorant SC', serif;">{{ $t('preorder.arrivalBtn') }}</button>
      </div>
      <div class="flex justify-center items-center mt-2 gap-3">
        <span class="w-2 h-2 rounded-full bg-gray-400 block"></span>
        <span class="w-2 h-2 rounded-full bg-[#F5BE32] block"></span>
        <span class="w-2 h-2 rounded-full bg-gray-400 block"></span>
        <span class="w-2 h-2 rounded-full bg-gray-400 block"></span>
      </div>
    </div>
  </div>
</template>
